import script from "./FooterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterSection.vue?vue&type=script&setup=true&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=25ff404a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ff404a"]])

export default __exports__